import React, { useState, useEffect, useContext } from "react";
import "./MatchesBoard.css";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Outlet } from "react-router-dom";
import Box from "@mui/system/Box";
import NetworkFreightMatches from "./NetworkFreightMatches/NetworkFreightMatches";
import useFreightMatchReceiver from "../../hooks/useFreightMatchReceiver/useFreightMatchReceiver";
import { CarrierService } from "../../services/CarrierService";
import { SecurityService } from "../../services/SecurityService";
import { ActiveUserContext, AlertContext } from "../Dashboard/Dashboard";

export default function MatchesBoard({
  handleTableAction
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const activeUser = useContext(ActiveUserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [freightMatches, setFreightMatches] = useState([]);
  const [newLoadsCount, setNewLoadsCount] = useState(0);
  const [regionUsers, setRegionUsers] = useState([]);
  const [selectedRegionUsers, setSelectedRegionUsers] = useState([]);
  const [radiusOrigin, setRadiusOrigin] = useState("50");
  const [radiusDest, setRadiusDest] = useState("50");
  const {
    newNetworkMatches,
    setNewNetworkMatches
  } = useFreightMatchReceiver("");

  const radiusOptions = [
    {
      name: "25 mi",
      value: "25"
    },
    {
      name: "50 mi",
      value: "50"
    },
    {
      name: "100 mi",
      value: "100"
    },
    {
      name: "150 mi",
      value: "150"
    },
    {
      name: "200 mi",
      value: "200"
    },
    {
      name: "250 mi",
      value: "250"
    },
    {
      name: "300 mi",
      value: "300"
    },
    {
      name: "350 mi",
      value: "350"
    },
    {
      name: "400 mi",
      value: "400"
    },
    {
      name: "450 mi",
      value: "450"
    },
    {
      name: "500 mi",
      value: "500"
    }
  ];

  const handleGetMatches = (manualRefresh = false) => {
    setTimeout(() => {
      const searchParams = {
        originSearchMiles: radiusOrigin,
        destinationSearchMiles: radiusDest,
        usersId: selectedRegionUsers.length === 0 ? "None" :
          selectedRegionUsers.length && selectedRegionUsers.length != regionUsers.map(option => option.children.map(child => child.userId)).flat().length ? selectedRegionUsers.join(",") : ""
      };

      setIsLoading(true);
      CarrierService.GetNetworkFreightMatches(instance, searchParams).then(res => {
        let filteredLoads = res.loads.filter(({ removedFlag }) => !removedFlag);
        filteredLoads.forEach(load => { load.newlyAdded = false; });
        setNewLoadsCount(0);

        if (newNetworkMatches && !manualRefresh) {
          let oldLoads = filteredLoads.filter(load => freightMatches.some(({ orderId, carrierId }) => orderId === load.orderId && carrierId === load.carrierId));
          let newLoads = filteredLoads.filter(load => !freightMatches.some(({ orderId, carrierId }) => orderId === load.orderId && carrierId === load.carrierId));
          newLoads.forEach(load => { load.newlyAdded = true; });
          setNewLoadsCount(newLoads.length);

          filteredLoads = newLoads.concat(oldLoads);
        }

        setFreightMatches(filteredLoads);
        setIsLoading(false);
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    }, 1);
  };

  useEffect(() => {
    handleGetMatches();
  }, [selectedRegionUsers, radiusOrigin, radiusDest]);

  useEffect(() => {
    if (newNetworkMatches) {
      handleGetMatches();
      setNewNetworkMatches(false);
    }
  }, [newNetworkMatches]);

  useEffect(() => {
    //Hint 3=Carrier rep manager, 4=Carrier rep
    SecurityService.GetUserByRoleId(instance, "3,4").then(res => {
      const excludedRegionNames = ["Afterhours", "Bull Pen", "PCCS", "Partials"];
      let filteredUsers = res.filter(({ regionName }) => !excludedRegionNames.includes(regionName));
      let regions = filteredUsers
        .filter((item, index, array) => array.findIndex(({ regionName }) => regionName === item.regionName) === index)
        .map(({ displayOrder, regionName }) => ({ displayOrder, regionName }));
      let regionUsersUpdated = [];

      regions.forEach(r => {
        regionUsersUpdated.push({
          parentName: r.regionName,
          parentId: r.displayOrder,
          open: true,
          children: filteredUsers.filter(({ regionName }) => regionName === r.regionName).map(({ userId, userName }) => ({ userId, userName }))
        });
      });
      setRegionUsers(regionUsersUpdated);
      setSelectedRegionUsers(
        activeUser.roleId === 4 ?
          [activeUser.userIdMcld] :
          activeUser.roleId === 3 ?
            regionUsersUpdated.filter(({ parentName }) => parentName === activeUser.region.regionName).map(option => option.children.map(child => child.userId)).flat() :
            regionUsersUpdated.map(option => option.children.map(child => child.userId)).flat()

      );
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  }, []);

  return (
    <Box sx={{ marginTop: "10px" }}>
      <NetworkFreightMatches
        isLoading={isLoading}
        freightMatches={freightMatches}
        setFreightMatches={setFreightMatches}
        newLoadsCount={newLoadsCount}
        regionUsers={regionUsers}
        setRegionUsers={setRegionUsers}
        selectedRegionUsers={selectedRegionUsers}
        setSelectedRegionUsers={setSelectedRegionUsers}
        radiusOptions={radiusOptions}
        radiusOrigin={radiusOrigin}
        setRadiusOrigin={setRadiusOrigin}
        radiusDest={radiusDest}
        setRadiusDest={setRadiusDest}
        handleGetMatches={handleGetMatches}
        handleTableAction={handleTableAction}
        newNetworkMatches={newNetworkMatches}
        setNewNetworkMatches={setNewNetworkMatches}
      />
      <Outlet />
    </Box>
  );
}

MatchesBoard.propTypes = {
  handleTableAction: PropTypes.func
};